<!-- Backdrop -->
<button
  type="button"
  tabindex="-1"
  class="fixed inset-0 z-40 p-0 bg-black opacity-0 transition-opacity duration-400 ease cursor-default"
  [class.opacity-40]="isExpanded"
  [class.pointer-events-none]="!isExpanded"
  [attr.aria-hidden]="!isExpanded"
  [attr.aria-label]="'Close menu' | translate"
  data-testid="mobile-home-menu-backdrop"
  (click)="closeMenu()"
></button>


<header class="relative z-50 pt-[env(safe-area-inset-top)] text-on-primary">
  <div class="relative z-10 flex items-center justify-between px-4 pt-1">
    <div class="flex items-center gap-2.5">
      <img
        [src]="branding.logoSrc"
        alt="Logo"
        class="w-auto overflow-hidden duration-400 ease"
        [ngClass]="isExpanded ? 'h-8 translate-5' : 'h-4'"
      />
      @if (branding.showScribeWordmark) {
        <div
          class="tpro-gradient duration-400 ease"
          [ngClass]="isExpanded ? 'translate-5 title-medium' : 'text-[9px]'"
        >
          Scribe
        </div>
      }
    </div>

    <button
      mat-icon-button
      type="button"
      class="!text-on-primary"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-label]="(isExpanded ? 'Close menu' : 'Open menu') | translate"
      data-testid="mobile-home-menu-toggle"
      (click)="toggleMenu()">
      @if (isExpanded) {
        <mat-icon svgIcon="close-affordance" class="icon-size [--icon-size:48px]"/>
      } @else {
        <mat-icon svgIcon="menu"/>
      }
    </button>
  </div>

  <div
    class="absolute inset-x-0 top-0 z-0 grid overflow-hidden bg-primary pb-2 pt-[calc(env(safe-area-inset-top)+2.5rem)] transition-[grid-template-rows,border-radius,padding] duration-400 ease-in-out"
    [ngClass]="
      isExpanded
        ? 'grid-rows-[1fr] pb-8 pt-[calc(env(safe-area-inset-top)+5.5rem)] rounded-b-2xl'
        : 'grid-rows-[0fr] rounded-b-none'"
    [class.pointer-events-none]="!isExpanded"
    [attr.aria-hidden]="!isExpanded"
  >
    <nav
      class="flex flex-col gap-2.5 min-h-0 overflow-hidden px-8"
      data-testid="mobile-home-menu-panel"
    >
      <a
        routerLink="/home"
        routerLinkActive="active"
        class="nav-menu-item expanded text-white"
        (click)="closeMenu()"
      >
        <mat-icon svgIcon="home"></mat-icon>
        <span>{{ 'Home' | translate }}</span>
      </a>
      <a
        routerLink="/encounters"
        routerLinkActive="active"
        class="nav-menu-item expanded text-white"
        (click)="closeMenu()"
      >
        <mat-icon svgIcon="encounters"></mat-icon>
        <span>{{ 'Encounters' | translate }}</span>
      </a>

      <div class="h-px w-full bg-[#f5fafd1f]"></div>

      @if (isAiBlueprintsEnabled) {
        <a
          routerLink="/ai-blueprints"
          routerLinkActive="active"
          class="nav-menu-item expanded text-white"
          (click)="closeMenu()"
        >
          <mat-icon svgIcon="ai-blueprints"></mat-icon>
          <span>{{ 'AI blueprints' | translate }}</span>
        </a>
      }
      @if (showMdrInformation) {
        <a
          routerLink="/information"
          routerLinkActive="active"
          class="nav-menu-item expanded text-white"
          (click)="closeMenu()"
        >
          <mat-icon svgIcon="info-circle"></mat-icon>
          <span>{{ 'MDR information' | translate }}</span>
        </a>
      }
      <a
        [href]="supportUrl"
        target="_blank"
        class="nav-menu-item expanded text-white"
        (click)="onSupportClick()"
      >
        <mat-icon svgIcon="support"></mat-icon>
        <span>{{ 'Support' | translate }}</span>
      </a>
      <a
        routerLink="/settings"
        routerLinkActive="active"
        class="nav-menu-item expanded text-white"
        (click)="closeMenu()"
      >
        <mat-icon svgIcon="settings"></mat-icon>
        <span>{{ 'Settings' | translate }}</span>
      </a>
      <button type="button" class="nav-menu-item expanded text-white cursor-pointer" (click)="onLogout()">
        <mat-icon class="material-symbols-outlined material-symbols-wght-300">logout</mat-icon>
        <span>{{ 'Logout' | translate }}</span>
      </button>

      <div class="h-px w-full bg-[#f5fafd1f]"></div>

      <div class="flex items-center h-17 w-full rounded-md p-2 justify-between">
        <div class="size-10 rounded-full shrink-0 overflow-hidden flex items-center justify-center">
          @if (avatarUrl) {
            <img [src]="avatarUrl" alt="avatar" class="w-full h-full object-cover rounded-full" />
          } @else {
            <mat-icon svgIcon="user-circle" class="icon-size [--icon-size:100%] [--icon-stroke-width:0.8px] text-inverse-on-surface"></mat-icon>
          }
        </div>
        <div class="text-inverse-on-surface flex-grow flex flex-col overflow-hidden ml-4">
          <div class="label-large-prominent whitespace-nowrap overflow-hidden text-ellipsis text-left" style="font-family: DM Sans, sans-serif">
            {{ user?.profile?.name || 'User' }}
          </div>
          <div class="label-medium overflow-hidden text-ellipsis text-left" style="font-family: DM Sans, sans-serif">
            {{ user?.entity?.name || '' }}
          </div>
        </div>
      </div>
    </nav>
  </div>
</header>
